import React, {
  ReactNode, useState, useEffect,
} from 'react';
import {
  IconButton, Popover,
} from '@mui/material';
import { MoreVert, Settings } from '@mui/icons-material';

interface Props {
  children?: ReactNode;
  altIcon?: boolean;
}

export function DropdownMenu({ children, altIcon = false }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [viewportWidth, setViewportWidth] = useState<number>(0);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const updateViewportWidth = () => {
      setViewportWidth(window.innerWidth);
    };

    updateViewportWidth();
    window.addEventListener('resize', updateViewportWidth);
    return () => window.removeEventListener('resize', updateViewportWidth);
  }, []);

  const toggle = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (!anchorEl) {
      setAnchorEl(event.currentTarget);
      return;
    }
    setAnchorEl(null);
  };

  const close = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="menu"
        aria-haspopup="true"
        onClick={toggle}
        size="small"
        color="inherit"
      >
        {altIcon ? <Settings /> : <MoreVert />}
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: viewportWidth < 768 ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: viewportWidth < 768 ? 'left' : 'right',
        }}
        open={open}
        onClose={close}
        PaperProps={{
          sx: {
            pointerEvents: 'auto',
            maxWidth: '90vw',
            '@media (max-width: 768px)': {
              maxWidth: 'calc(100vw - 32px)',
            },
          },
        }}
      >
        {children}
      </Popover>
    </>
  );
}
